import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ActionButtonIcons } from './action-button-icons';
import { ActionButtonImages } from './action-button-images.enum';

@Component({
  selector: 'ls-action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss']
})
export class ActionButtonComponent {
  @Input()
  public title: string;
  @Input()
  public icon: ActionButtonIcons;
  @Input()
  public imageIcon: ActionButtonImages;
  @Input()
  public highlight: boolean;
  @Input()
  public disabled: boolean;

  @Output()
  public action: EventEmitter<MouseEvent> = new EventEmitter();

  public onClick(event: MouseEvent): void {
    if (!this.disabled) {
      this.action.emit(event);
    }
  }
}
